import { render, staticRenderFns } from "./Prosecute.vue?vue&type=template&id=4e512bc1"
import script from "./Prosecute.vue?vue&type=script&lang=js"
export * from "./Prosecute.vue?vue&type=script&lang=js"
import style0 from "./Prosecute.vue?vue&type=style&index=0&id=4e512bc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports